import { getTestDimensionTitleElementId } from '@upright/test-ids/dom-elements';
import styled from 'styled-components';
import { friendlyDimensionName } from '../../../../../../../../../../common/model/texts/friendly-dimension-name';
import { dimensionIcon } from '../../../../../../../../generic/components/icons/dimensions';
import { bouTextFont } from '../../../../../../../../generic/content/texts/bou-text/text-style';
import { BouColor } from '../../../../../../../../generic/global/bou-colors';
import {
  useImpactChartContext,
  useImpactChartFontSizes,
  useImpactChartHeights,
  useImpactChartWidths,
} from '../../../context';
import { DimensionRowProps } from '../types';
import ArrowRight from './arrow-right.svg';

const chevronSize = 8;

export function DimensionRowLeftPart(props: DimensionRowProps) {
  const heights = useImpactChartHeights();
  const widths = useImpactChartWidths();
  const { isExpanded, staticMode, language } = useImpactChartContext();
  const { dimensionTitles } = useImpactChartFontSizes();
  const height = heights.dimensionRowLeftPart;
  const rotation = isExpanded(props.dimension) ? 90 : 0;
  const Icon = dimensionIcon(props.dimension);
  const iconHeight = 13;
  return (
    <g>
      <MainG transform={`translate(0, ${height / 2})`}>
        {!staticMode && (
          <g transform={`translate(${widths.commonHorizontalPadding}, ${-chevronSize / 2}) `}>
            <ChevronWrapGroup style={{ transform: `rotate(${rotation}deg)` }}>
              <ChevronIcon />
            </ChevronWrapGroup>
          </g>
        )}
        <g transform={`translate(${widths.titleIconLeftLine}, ${-iconHeight / 2})`}>
          <Icon height={iconHeight} width={iconHeight} color="#333333" />
        </g>
        <g transform={`translate(${widths.titleTextLeftLine}, 0)`}>
          <Title id={getTestDimensionTitleElementId(props.dimension)} dy="0.35em" style={{ fontSize: dimensionTitles }}>
            {friendlyDimensionName(props.dimension, language)}
          </Title>
        </g>
      </MainG>
    </g>
  );
}

const MainG = styled.g`
  transition: transform 0.12s ease-in-out;
`;

const Title = styled.text`
  ${bouTextFont};
  fill: ${BouColor.BLACK};
  font-weight: 600;
`;

function ChevronIcon() {
  // The streamline npm packages does not work inside svg's
  // since it creates a span element around the actual svg
  // Therefore we are using a manually copied svg asset -- JO
  return <ArrowRight width={chevronSize} height={chevronSize} stroke={BouColor.BLACK} />;
}

const ChevronWrapGroup = styled.g`
  transform-origin: ${chevronSize / 2}px ${chevronSize / 2}px;
  transition: transform 0.2s ease-in-out;
`;
